import React from 'react';
import { StructuredText } from "react-datocms";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function FAQ({ record }) {
  // Debug log to see the entire record structure
  console.log('Full FAQ record:', JSON.stringify(record, null, 2));

  // Function to convert structured text to plain text
  const structuredTextToPlainText = (structuredData) => {
    try {
      if (!structuredData?.value?.document?.children) return '';

      const extractText = (node) => {
        if (node.type === 'span') {
          return node.value || '';
        }
        
        if (node.type === 'listItem') {
          return '• ' + (node.children || []).map(extractText).join('');
        }
        
        if (node.children) {
          return node.children.map(extractText).join('');
        }
        
        return '';
      };

      return structuredData.value.document.children
        .map(block => {
          if (block.type === 'paragraph') {
            return extractText(block);
          }
          if (block.type === 'list') {
            return block.children
              .map(item => extractText(item))
              .join('\n');
          }
          return '';
        })
        .filter(Boolean)
        .join('\n')
        .trim();
    } catch (error) {
      console.error('Error processing structured text:', error);
      return '';
    }
  };

  // Safely get items and debug
  const items = record?.items || record?.faqItems || [];
  console.log('FAQ items:', items.map(item => ({
    question: item.question,
    answerType: typeof item.answer,
    answerKeys: item.answer ? Object.keys(item.answer) : null
  })));
  
  // Create the structured data
  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": structuredTextToPlainText(item.answer)
      }
    }))
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqStructuredData)
        }}
      />
      <Accordion type="single" collapsible>
        {items.map((item, index) => (
          <AccordionItem key={index} value={`faq-${index}`} className="px-0">
            <AccordionTrigger>{item.question}</AccordionTrigger>
            <AccordionContent>
              <div className="body-text">
                <StructuredText
                  data={{
                    schema: item.answer.value.schema,
                    document: item.answer.value.document
                  }}
                />
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
}